import { LOCAL_STORAGE_KEYS } from "./Constants";

const LANGUAGES = ['EN', 'IT'];

const translations = {
   EN: {
      appDownload: 'Download App',
      shopName: 'Location',
      shopNameRequired:'Select Store Location',
      shopNamePlaceholder:'Select Store Location',
      turin:'Turin',
      milan:'Milan',
      home404Subtitle: 'Sorry, it looks like you do not have permission to access this area',
      loginEmailLabel: 'E-mail',
      loginEmailInvalid: 'The e-mail field is not valid',
      loginEmailRequired: 'Enter an E-mail',
      loginPasswordLabel: 'Password',
      loginPasswordRequired: 'Please enter a password',
      loginButton: 'Login',
      loginRegisterPrompt: "Don't have an account?",
      loginRegisterLink: 'Register',
      registerName: 'Name',
      registerNameRequired: 'Please enter your name',
      registerSurname: 'Surname',
      registerSurnameRequired: 'Please enter your surname',
      registerBirthDate: 'Date of Birth',
      birthDatePlaceholder: 'Select date',
      registerEmail: 'E-mail',
      emailInvalid: 'The e-mail address is not valid',
      emailRequired: 'Enter an e-mail',
      registerPassword: 'Password',
      passwordRequired: 'Please enter a password',
      registerConfirmPassword: 'Confirm Password',
      confirmPasswordRequired: 'Please confirm your password',
      passwordMismatch: 'Passwords do not match',
      registerMobile: 'Mobile Phone',
      registerMobileRequired: 'Please enter your mobile phone number',
      registerPhone: 'Phone',
      registerPhoneRequired: 'Please enter your phone number',
      registerGender: 'Gender',
      genderPlaceholder: 'Select your gender',
      genderRequired: 'Please select your gender',
      registerLotteryCode: 'Lottery Code',
      registerTaxCode: 'Tax Code',
      registerRegion: 'Region',
      regionRequired: 'Please select your region',
      registerProvince: 'Province',
      provinceRequired: 'Please select your province',
      registerCity: 'City',
      cityRequired: 'Please select your city',
      registerZipCode: 'ZIP Code',
      zipCodeRequired: 'Please select your ZIP Code',
      registerAddress: 'Address',
      addressRequired: 'Please enter your address',

      consentMarketing: 'I consent to the processing of my data for marketing purposes.',
      consentMarketingThirdParties: 'I consent to the processing of data for third-party marketing purposes.',
      
      consentMarketingXerjoff: 'Consent to the processing of personal data for profiling purposes. I agree to the processing of my personal data for profiling purposes, including the analysis of preferences and purchase behavior, to receive personalized offers and improve my browsing experience.',
      consentMarketingThirdPartiesXerjoff: 'Sign up for our newsletter. I authorize the processing of my personal data by Xerjoff Group S.p.A. for sending advertising or direct sales communications, invitations to promotional events, and for carrying out market research or commercial communications, through automated or traditional contact methods.',
      
      termsAgreementPrefix: 'I agree to the',
      termsAndConditionsLink: 'Terms of Use and Privacy Policy',
      
      termsError: 'You must accept the Terms and Conditions',
      registerButton: 'Register',
      registerLoginPrompt: 'Already have an account?',
      registerLoginLink: 'Login',
      privacyPolicyTitle: 'Privacy Policy',
      smartCardBalance: 'Balance',
      smartCardCoupons: 'Coupons',
      logout: 'Logout',
      smartCardActivity: 'Activity',
      smartCardLastActivity: 'Last activity',
      smsActivationLabel: 'Send card also via SMS',
      smartCardCardNumber: 'No.',
      man: 'Man',
      woman: 'Woman',
      other: 'Other',
      
      // Traduzioni aggiunte
      registerLoading: 'Registration in progress...',
      userNotEnabled: 'User not enabled',
      invalidData: 'Invalid data or user does not exist',
      userAlreadyExists: 'User already exists',
      registerLoginLink: 'Login',
      man: 'Man',
      woman: 'Woman',
      other: 'Other',
      registerName: 'Name',
      registerSurname: 'Surname',
   },
   IT: {
      appDownload: 'Scarica l\'App',
      home404Subtitle: 'Mi spiace, sembra che tu non abbia l\'abilitazione ad accedere a quest\'area',
      shopName: 'Punto Vendita',
      shopNameRequired:'Seleziona il punto vendita',
      shopNamePlaceholder:'Seleziona il punto vendita',
      turin:'Torino',
      milan:'Milano',
      loginEmailLabel: 'E-mail',
      loginEmailInvalid: 'Il campo E-Mail non è valido',
      loginEmailRequired: 'Inserire una E-mail',
      loginPasswordLabel: 'Password',
      loginPasswordRequired: 'Si prega di inserire una password',
      loginButton: 'Accedi',
      loginRegisterPrompt: 'Non hai un account?',
      loginRegisterLink: 'Registrati',
      registerName: 'Nome',
      registerNameRequired: 'Inserire il Nome',
      registerSurname: 'Cognome',
      registerSurnameRequired: 'Inserire il Cognome',
      registerBirthDate: 'Data di Nascita',
      birthDatePlaceholder: 'Seleziona data',
      registerEmail: 'E-mail',
      emailInvalid: 'Il campo E-Mail non è valido',
      emailRequired: 'Inserire una E-mail',
      registerPassword: 'Password',
      passwordRequired: 'Si prega di inserire una password',
      registerConfirmPassword: 'Conferma Password',
      confirmPasswordRequired: 'Conferma la password',
      passwordMismatch: 'La Password sembra non corrispondere',
      registerMobile: 'Cellulare',
      registerMobileRequired: 'Inserire il numero di cellulare',
      registerPhone: 'Telefono',
      registerPhoneRequired: 'Inserire il numero di telefono',
      registerGender: 'Genere',
      genderPlaceholder: 'Seleziona il tuo genere',
      genderRequired: 'Seleziona il tuo genere',
      registerRegion: 'Regione',
      regionRequired: 'Seleziona la regione',
      registerProvince: 'Provincia',
      provinceRequired: 'Seleziona la provincia',
      registerLotteryCode: 'Codice Lotteria',
      registerTaxCode: 'Codice Fiscale',
      registerCity: 'Comune',
      cityRequired: 'Seleziona il tuo Comune',
      registerZipCode: 'CAP',
      zipCodeRequired: 'Seleziona il CAP',
      registerAddress: 'Indirizzo',
      addressRequired: 'Inserisci il tuo indirizzo',

      consentMarketing: 'Acconsento al trattamento dei dati per finalità di marketing',
      consentMarketingThirdParties: 'Acconsento al trattamento dei dati per finalità di marketing per terze parti',
      
      consentMarketingXerjoff: "Consenso al trattamento dei dati personali per finalità di profilazione. Acconsento al trattamento dei miei dati personali per finalità di profilazione, inclusa l'analisi delle preferenze e delle abitudini di acquisto, al fine di ricevere offerte personalizzate e migliorare la mia esperienza di navigazione.",
      consentMarketingThirdPartiesXerjoff: "Iscriviti alla nostra newsletter. Autorizzo il trattamento dei miei dati personali da parte di Xerjoff Group S.p.A. per l'invio di comunicazioni pubblicitarie o di vendita diretta, inviti ad eventi promozionali, svolgimento di ricerche di mercato o comunicazioni commerciali, attraverso modalità di contatto automatizzate o tradizionali.",

      termsAgreementPrefix: 'Accetto',
      termsAndConditionsLink: "Termini d'Uso e l'Informativa sulla Privacy",

      termsError: 'Devi accettare i Termini e Condizioni',
      registerButton: 'Registrati',
      registerLoginPrompt: 'Hai già un account?',
      registerLoginLink: 'Accedi',
      privacyPolicyTitle: 'Privacy Policy',
      smartCardBalance: 'Saldo',
      smartCardCoupons: 'Coupons',
      logout: 'Logout',
      smartCardActivity: 'Attività',
      smartCardLastActivity: 'Ultima attività',
      smsActivationLabel: 'Invia card anche via SMS',
      smartCardCardNumber: 'N°',
      man: 'Uomo',
      woman: 'Donna',
      other: 'Altro',
      
      // Traduzioni aggiunte
      registerLoading: 'Registrazione in corso...',
      userNotEnabled: 'Utente non abilitato',
      invalidData: 'Dati errati o utente non esistente',
      userAlreadyExists: 'Utente già esistente',
   },
};

function getStoredLanguage(defaultLanguage = 'IT') {
  if (typeof window === 'undefined') return defaultLanguage;
  const stored = window.localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE);
  return stored && LANGUAGES.includes(stored) ? stored : defaultLanguage;
}

function setStoredLanguage(code) {
  if (typeof window === 'undefined') return;
  if (LANGUAGES.includes(code)) {
    window.localStorage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, code);
  }
}

export { translations, getStoredLanguage, setStoredLanguage, LANGUAGES };